import React, { useContext } from "react";

import { ArrowBack } from "@mui/icons-material";
import { Button, Container, Grid, Paper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router";

import "@/components/UserManagement/User/UserManagement.scss";
import { AuthStateContext } from "@/contexts/AuthContext";

import UpdateUserPage from "./UpdateUserPage";
import ViewUserPage from "./ViewUserPage";

const UserPage: React.FC<{
  mode: "add" | "edit" | "view";
  profile: boolean;
}> = ({ mode, profile }) => {
  const { currentUser } = useContext(AuthStateContext);
  const navigate = useNavigate();
  const { orgId, userId } = useParams();

  const handleBack = () => {
    if (profile) {
      if (mode === "edit") {
        navigate(`/users/${userId}/profile`);
      } else {
        navigate(-1);
      }
      return;
    }
    if (mode === "edit" && orgId && userId) {
      navigate(`/organizations/${orgId}/users/${userId}`);
    } else if (orgId) {
      navigate(`/organizations/${orgId}/users`);
    } else {
      navigate(-1);
    }
  };
  const pageTitle = {
    add: "Add New User",
    edit: "Modify User",
    view: "User Details",
  };

  const profileTitle = {
    edit: "Profile",
    view: "Profile",
  };
  return (
    <div style={{ position: "relative" }}>
      <Button
        style={{ position: "absolute", top: "16px" }}
        startIcon={<ArrowBack />}
        className="cancel_button"
        disabled={currentUser?.profile_update_required && mode === "edit"}
        variant="outlined"
        color="primary"
        size="large"
        onClick={handleBack}
      >
        Back
      </Button>
      <Container maxWidth="md" className="user-page-container">
        <Paper className="user-details-paper">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
              <Typography variant="h4" gutterBottom>
                {profile ? profileTitle[mode] : pageTitle[mode]}
              </Typography>
              {profile && mode === "edit" && (
                <Typography variant="body2" gutterBottom>
                  All required fields must be completed and saved before using
                  the system
                </Typography>
              )}
            </Grid>
          </Grid>
          {mode === "add" && <UpdateUserPage />}
          {mode === "edit" && <UpdateUserPage />}
          {mode === "view" && <ViewUserPage />}
        </Paper>
      </Container>
    </div>
  );
};

export default UserPage;
